module.exports = __webpack_public_path__ + "static/media/icone-condutor-legal.3af79e2f.png";